import DatasetsLayoutNodeVisitor from '../dataset-tree/layout/DatasetsLayoutNodeVisitor';
import HorizontalStackLayoutNode from '../dataset-tree/layout/HorizontalStackLayoutNode';
import SingleDatasetLayoutNode from '../dataset-tree/layout/SingleDatasetLayoutNode';
import VerticalStackLayoutNode from '../dataset-tree/layout/VerticalStackLayoutNode';

import TitleCollatorVisitorDelegate from './TitleCollatorVisitorDelegate';

/**
 * Traverses the layout hierarchy and infers UI element titles for non-leaf
 * elements.
 */
class TitleCollatorVisitor implements DatasetsLayoutNodeVisitor {
  private title: string | null = null;

  constructor(private delegate: TitleCollatorVisitorDelegate) {}

  public getCollatedTitle(): string | null {
    return this.title;
  }

  public visitSingleDataset(node: SingleDatasetLayoutNode): void {
    this.title = this.delegate.getDatasetTitle(node.getDataset());
  }

  public visitTabs(): void {
    this.title = null;
  }

  public visitVerticalStack(node: VerticalStackLayoutNode): void {
    this.chooseFirstNonNull(node);
  }

  public visitHorizontalStack(node: HorizontalStackLayoutNode): void {
    this.chooseFirstNonNull(node);
  }

  private chooseFirstNonNull(
    node: HorizontalStackLayoutNode | VerticalStackLayoutNode
  ): void {
    for (const child of node.getChildren()) {
      const childVisitor = new TitleCollatorVisitor(this.delegate);

      child.acceptVisitor(childVisitor);

      if (childVisitor.getCollatedTitle() !== null) {
        this.title = childVisitor.getCollatedTitle();
        return;
      }
    }
  }
}

export default TitleCollatorVisitor;
